import { createAction } from 'redux-act';

export const showLoader = createAction('Show_loader');
export const hideLoader = createAction('Hide_loader');
export const showLoaderWithMeta = createAction('Show_loader_with_meta');
export const hideLoaderWithMeta = createAction('Hide_loader_with_meta');
